import { render, staticRenderFns } from "./logwood-packages-location-table.vue?vue&type=template&id=d48e2690&"
import script from "./logwood-packages-location-table.vue?vue&type=script&lang=ts&"
export * from "./logwood-packages-location-table.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d48e2690')) {
      api.createRecord('d48e2690', component.options)
    } else {
      api.reload('d48e2690', component.options)
    }
    module.hot.accept("./logwood-packages-location-table.vue?vue&type=template&id=d48e2690&", function () {
      api.rerender('d48e2690', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/logwood/components/logwood-packages-location-table.vue"
export default component.exports